// Module
var code = "<a href=\"javascript:;\" class=\"text-sm sps-btn sps-btn-outline btn-color-list list-screen-button\"> <i class=\"fa fa-list\" align=\"center\"></i><span data-bind=\"text: _labels.LIST\"></span> </a>";
// Exports
export default code;